import { useAuthStore } from '@/stores/useAuthStore'
import Cookies from 'js-cookie'

export const TOKEN_KEY = '_mtrack_access_token'

export const tokenStorage = {
  setToken: (token: string) => {
    Cookies.set(TOKEN_KEY, token)
  },

  removeToken: () => {
    Cookies.remove(TOKEN_KEY)
  },

  getToken: () => {
    return Cookies.get(TOKEN_KEY)
  },
}

export const clearAuthSession = () => {
  tokenStorage.removeToken()
  useAuthStore.getState().removeCurrentUser()
}
